import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { RppPatientService } from "../../rpp-patient-list/services/rpp-patient.service";
import {
  Country,
  District,
  Gender,
  LeadSorce,
  PatientDetails,
  State,
} from "../registration.interface";
import { MessageService, SelectItem } from "primeng/api";
import { BasicRegistrationService } from "../../hospital-basic-registration/services/basic-registration.service";
import { LocationService, UtilsService } from "src/app/modules/shared/services";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { combineLatest, forkJoin, Subscription } from "rxjs";
import moment from "moment";
import { RegistrationService } from "../registration.service";
import { count } from "console";

enum AddressUpdateType {
  Copy = "copy",
  Update = "update",
}

export const CSR_STATUS = {
  REGULAR_VALUE: "regular",
  REGULAR_LABEL: "Regular",
};
@Component({
  selector: "app-demographics",
  templateUrl: "./demographics.component.html",
  styleUrls: ["./demographics.component.scss"],
})
export class DemographicsComponent implements OnInit, OnDestroy {
  allLeadSourceOptions: any[] = [];
  leadSourceOptions: any[] = [];
  countryOptions: SelectItem[] = [];
  genderOptions: SelectItem[] = [];
  stateCurrentOptions: SelectItem[] = [];
  districtCurrentOptions: SelectItem[] = [];
  statePermanentOptions: SelectItem[] = [];
  districtPermanentOptions: SelectItem[] = [];
  @Input() registrationForm: FormGroup;
  permanantAddressAutoFill: boolean = false;
  searchPhone: string = "";
  disableNvfRevokeDate: boolean = true;
  @Input() submit: boolean = false;
  minYear: number = 1924;
  minMonth: number = 0; // January is 0-indexed
  disablePreviousNavigation: boolean = false;
  maxDate: Date;
  currentYear: number;
  @ViewChild("dobCalendar", { static: true }) dobCalendar: ElementRef;
  @Input() selectedService: string = "";
  @Input() occupationlist: any;
  @Input() maritalList: any;
  @Input() educationList: any;
  @Input() patientID: any;
  @Input() userTitle: any;
  @Input() photo_id_type: any;
  @Output() patientDetails = new EventEmitter<PatientDetails>();
  clientSearch = new FormControl();
  patientDetailsData: PatientDetails;
  disableSearchPhone: boolean = false;
  newMobileNumber: number = null;
  @ViewChild("addressCheckbox") addressCheckbox!: ElementRef<HTMLInputElement>;
  permanentAddressUpdateType: AddressUpdateType;
  AddressUpdateType = AddressUpdateType;
  marketingUserOptions: SelectItem[] = [];
  previousValues: { [key: string]: any } = {};
  @Output() resetRegistrationType = new EventEmitter<boolean>();

  csrListOptions: SelectItem[];
  isRegularCsrSelected: boolean = false;
  private isLeadSourceWarningVisible = false;
  revokeOptions: SelectItem[] = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  filteredClients: any[] = [];
  selectedClient: any = null;


  constructor(
    private rppRegService: RppPatientService,
    private basicRegService: BasicRegistrationService,
    private locationsService: LocationService,
    private messageService: MessageService,
    private utils: UtilsService,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    const currentDate = moment();
    this.maxDate = currentDate.subtract(3, "years").toDate(); // max date set to 3 years ago from today
    this.currentYear = currentDate.year(); // get the current year
    // this.getLeadSourceOptions();
    this.getCountryOptions();
    this.getGenderOptions();
    this.getStateOptions();
    this.watchCurrentAddress();
    this.getMarketingUserList();
    // this.getCsrList();
    this.loadCsrAndLeadSources();
    this.handleCsrChanges();

    this.registrationForm.get("patientName").valueChanges.subscribe((val) => {
      if (val) {
        const trimmed = val.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
        if (val !== trimmed) {
          this.registrationForm
            .get("patientName")
            .setValue(trimmed, { emitEvent: false });
        }
      }
    });

    // this.registrationForm.get('csr_id')?.valueChanges.subscribe(val => {
    //   if (!val || !this.allLeadSourceOptions?.length) return;

    //   const csrValue = val.toString().trim().toLowerCase();

    //   this.leadSourceOptions = this.allLeadSourceOptions.filter(res => {
    //     const type = res.leadType?.toString().trim().toLowerCase();
    //     if (!type) return false;

    //     return csrValue === CSR_STATUS.REGULAR_VALUE
    //       ? type === CSR_STATUS.REGULAR_VALUE
    //       : type === 'csr';
    //   });
    // this.registrationForm.get('leadSourceId')?.reset();
  }

  ngOnDestroy(): void {}

  // Search clients using p-autoComplete
  searchClients(event: any) {
    const query = event.query;
    
    if (!query || query.length < 3) {
      this.filteredClients = [];
      return;
    }

    this.basicRegService.searchClientBySearchKeyword(query).subscribe({
      next: (res: any) => {
        this.filteredClients = res?.data || [];
        
        // If query is a 10-digit number and no results found, add "new number" option
        const isNumeric = /^\d{10}$/.test(query);
        if (isNumeric && this.filteredClients.length === 0) {
          this.filteredClients = [{
            patient_id: null,
            patient_name: 'New Registration',
            mobile_number: query,
            isNewNumber: true
          }];
        }
      },
      error: () => {
        this.filteredClients = [];
        
        // If query is a 10-digit number, show as new number option even on error
        const isNumeric = /^\d{10}$/.test(query);
        if (isNumeric) {
          this.filteredClients = [{
            patient_id: null,
            patient_name: 'New Registration',
            mobile_number: query,
            isNewNumber: true
          }];
        }
      }
    });
  }

  // Handle client selection from dropdown
  onClientSelect(event: any) {
    // event is the selected client object
    this.selectedClient = event;
    // field="mobile_number" automatically sets searchPhone, but ensure it's a string
    this.searchPhone = event.mobile_number?.toString();
    
    // Trigger searchWithPhoneNumber for both new and existing clients
    setTimeout(() => {
      this.searchWithPhoneNumber();
    }, 100);
  }

  makeOthersFieldMandatory(
    controlName: string,
    otherControlName: string,
    value: any,
  ) {
    const rppGroup = this.registrationForm.get(
      "rppRegistrationForm",
    ) as FormGroup;
    const actualValue = rppGroup.get(controlName)?.value;
    const otherCtrl = rppGroup.get(otherControlName);

    if (!otherCtrl) return;

    // Clear validators first
    otherCtrl.clearValidators();

    // If occupation_code matches given value, set required validator
    if (actualValue == value) {
      otherCtrl.setValidators([Validators.required]);
    }

    otherCtrl.updateValueAndValidity();
  }

  getPhotoId(event: any) {
    const controls = (
      this.registrationForm.get("rppRegistrationForm") as FormGroup
    ).controls;
    const controlKeys = ["aadhar", "passport", "voter_id", "driving"];

    // Keep previous values in memory
    if (!this.previousValues) {
      this.previousValues = {};
    }

    controlKeys.forEach((key) => {
      const ctrl = controls[key];
      if (ctrl?.value) {
        this.previousValues[key] = ctrl.value;
      }
      ctrl?.setValue(null);
      ctrl?.clearValidators();
      ctrl?.updateValueAndValidity();
    });

    this.photo_id_type = parseInt(event.value);

    let selectedKey: string | null = null;
    switch (this.photo_id_type) {
      case 1:
        selectedKey = "passport";
        break;
      case 2:
        selectedKey = "aadhar";
        break;
      case 3:
        selectedKey = "voter_id";
        break;
      case 4:
        selectedKey = "driving";
        break;
    }

    if (selectedKey) {
      // Restore previous value if available
      const prevVal = this.previousValues[selectedKey] || null;
      controls[selectedKey].setValue(prevVal);

      // Photo ID fields are optional - no validators required
      controls[selectedKey].updateValueAndValidity();
      controls[selectedKey].markAsTouched();
    }
  }

  sanitizeNumberInput(event: any) {
    const input = event.target;
    const sanitized = input.value.replace(/\D/g, "");
    input.value = sanitized;

    const aadharCtrl = this.registrationForm.get("rppRegistrationForm.aadhar");
    aadharCtrl?.setValue(sanitized, { emitEvent: false });
  }

  getMarketingUserList() {
    this.basicRegService.getMarketingUser().subscribe((res: any) => {
      const options = res.data.map((item: any) => ({
        label: item.display_name,
        value: item.user_id,
      }));

      options.sort((a, b) => a.label.localeCompare(b.label));
      this.marketingUserOptions = options;
    });
  }

  // getCsrList() {
  //   this.csrListOptions = [{ label: CSR_STATUS.REGULAR_LABEL, value: CSR_STATUS.REGULAR_VALUE }];

  //   const regularOption = this.csrListOptions[0];

  //   this.basicRegService.getCsrList().subscribe({
  //     next: (res: any) => {
  //       const options = res.data.map((item: any) => ({
  //         label: `${item.shortName} - ${item.name}`,
  //         value: item._id,
  //       }));

  //       options.sort((a, b) => a.label.localeCompare(b.label));

  //       this.csrListOptions = [
  //         regularOption,
  //         ...options,
  //       ];

  //       const firstOption = this.csrListOptions[0];
  //       this.registrationForm.patchValue({
  //         csr_id: firstOption.value,
  //       });
  //     },
  //     error: (err) => {
  //       this.registrationForm.patchValue({
  //         csr_id: regularOption.value,
  //       });
  //     },
  //   });
  // }

  onMarketingPersonChange(event: any) {
    if (event.value) {
      this.marketingUserOptions.forEach((res: any) => {
        if (res.value === event.value) {
          this.registrationForm.get("marketing_person_id").setValue(res.value);
          this.registrationForm
            .get("marketing_person_name")
            .setValue(res.label);
        }
      });
    }
  }

  loadCsrAndLeadSources() {
    forkJoin({
      csrList: this.basicRegService.getCsrList(),
      leadSources: this.rppRegService.getAllLeadSource(),
    }).subscribe({
      next: ({ csrList, leadSources }: { csrList: any; leadSources: any }) => {
        // Prepare CSR options with value = _id
        const regularOption = {
          label: CSR_STATUS.REGULAR_LABEL,
          value: CSR_STATUS.REGULAR_VALUE,
          type: "Regular",
        };
        const csrOptions = csrList.data
          .map((item: any) => ({
            label: `${item.shortName} - ${item.name}`,
            value: item._id,
            type: item.shortName, // store type for filtering
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.csrListOptions = [regularOption, ...csrOptions];

        // Set default CSR
        const firstOption = this.csrListOptions[0];
        this.registrationForm.patchValue({
          csr_id: firstOption.value,
        });

        // Populate lead sources
        this.resetArray(this.leadSourceOptions);
        this.resetArray(this.allLeadSourceOptions);
        leadSources.data.forEach((item: any) => {
          const option = {
            label: item.lead_source,
            value: item.lead_source_id,
            leadType: item.lead_type,
          };
          this.leadSourceOptions.push(option);
          this.allLeadSourceOptions.push(option);
        });

        // Filter based on initial CSR
        this.filterLeadSources(firstOption);
      },
      error: (err) => {
        console.error(err);
        this.registrationForm.patchValue({ csr_id: CSR_STATUS.REGULAR_VALUE });
      },
    });
  }

  // Updated filterLeadSources
  filterLeadSources(csr: { value: string; type?: string }) {
    if (!csr || !this.allLeadSourceOptions?.length) return;

    const csrType = (csr.type || "").toLowerCase();

    this.leadSourceOptions = this.allLeadSourceOptions.filter((res) => {
      const leadType = (res.leadType || "").toLowerCase();

      if (!leadType) return false;

      return leadType === csrType;
    });

    const oldLeadSource = this.leadSourceOptions.find(
      (res) => res.value === this.patientDetailsData?.lead_source_id,
    );

    if (
      !oldLeadSource &&
      this.patientDetailsData?.lead_source_id &&
      !this.isLeadSourceWarningVisible
    ) {
      this.isLeadSourceWarningVisible = true;

      this.messageService.add({
        key: "leadSourceWarning",
        severity: "warn",
        summary: "Lead Source Updated",
        detail: `The previous Lead Source (${this.patientDetailsData?.lead_source}) is no longer available. Please select a new Lead Source before continuing.`,
        sticky: true,
      });
    } else if (oldLeadSource) {
      this.messageService.clear("leadSourceWarning");
      this.isLeadSourceWarningVisible = false;
    }

    // Reset leadSource selection
    // this.registrationForm.get('leadSourceId')?.reset();
  }

  // valueChanges subscription
  handleCsrChanges() {
    this.registrationForm.get("csr_id")?.valueChanges.subscribe((val) => {
      const selectedCsr = this.csrListOptions.find((c) => c.value === val);
      if (selectedCsr) this.filterLeadSources(selectedCsr);
    });
  }

  // getLeadSourceOptions() {
  //   this.rppRegService.getAllLeadSource().subscribe((res: any) => {
  //     this.resetArray(this.leadSourceOptions);
  //     this.resetArray(this.allLeadSourceOptions)
  //     res.data.forEach((item: LeadSorce) => {
  //       this.leadSourceOptions.push({ label: item.lead_source, value: item.lead_source_id,  leadType: item.lead_type });
  //       this.allLeadSourceOptions.push({ label: item.lead_source, value: item.lead_source_id,  leadType: item.lead_type });;
  //     })
  //   });
  // }

  getCountryOptions() {
    this.basicRegService.getCountryMaster().subscribe((res: any) => {
      this.resetArray(this.countryOptions);
      res.forEach((item: Country) => {
        this.countryOptions.push({
          label: item.country_name,
          value: item.country_id,
        });
      });
      this.registrationForm.get("countryId").setValue(1); //India
      this.registrationForm.get("countryName").setValue("India");
      this.registrationForm.get("countryId").disable();
    });
  }

  getGenderOptions() {
    this.basicRegService.getGender().subscribe((res: any) => {
      this.resetArray(this.genderOptions);
      res.forEach((item: Gender) => {
        this.genderOptions.push({
          label: item.field_value,
          value: item.field_code,
        });
      });
    });
  }

  getStateOptions() {
    this.locationsService.getStates().subscribe((res: any) => {
      this.resetArray(this.stateCurrentOptions);
      this.resetArray(this.statePermanentOptions);
      res.forEach((item: State) => {
        this.stateCurrentOptions.push({
          label: item.state_name,
          value: item.state_id,
        });
        this.statePermanentOptions.push({
          label: item.state_name,
          value: item.state_id,
        });
      });
    });
  }

  getDistrictOptions(stateId: any, type: string): Promise<void> {
    return this.utils
      .toPromise(this.locationsService.getDistricts(stateId))
      .then((res) => {
        switch (type) {
          case "current":
            this.resetArray(this.districtCurrentOptions);
            this.registrationForm.get("currentDistrictId").setValue(null);
            res.forEach((item: District) => {
              this.districtCurrentOptions.push({
                label: item.district_name,
                value: item.district_id,
              });
            });
            break;
          case "permanent":
            this.resetArray(this.districtPermanentOptions);
            this.registrationForm.get("permanentDistrictId").setValue(null);
            res.forEach((item: District) => {
              this.districtPermanentOptions.push({
                label: item.district_name,
                value: item.district_id,
              });
            });
            break;
          default:
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Cannot fetch district options",
            });
            throw new Error("Cannot fetch district options");
        }
      })
      .catch((error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Cannot fetch district options",
        });
        throw error;
      });
  }

  copyCurrentAddress(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.permanentAddressUpdateType = AddressUpdateType.Copy;
      this.districtPermanentOptions = JSON.parse(
        JSON.stringify(this.districtCurrentOptions),
      );
      this.registrationForm.patchValue({
        permanentAddress: this.registrationForm.get("currentAddress").value,
        permanentStateId: this.registrationForm.get("currentStateId").value,
        permanentDistrictId:
          this.registrationForm.get("currentDistrictId").value,
      });
    } else {
      this.registrationForm.patchValue({
        permanentAddress: "",
        permanentStateId: null,
        permanentDistrictId: null,
      });
      this.resetArray(this.districtPermanentOptions);
    }
  }

  resetArray(array: SelectItem[]) {
    array.length = 0;
  }

  watchCurrentAddress() {
    combineLatest([
      this.registrationForm.get("currentAddress").valueChanges,
      this.registrationForm.get("currentStateId").valueChanges,
    ]).subscribe(([address, stateId]) => {
      if (address && stateId) {
        this.permanantAddressAutoFill = true;
      } else {
        this.permanantAddressAutoFill = false;
      }
    });
  }

  setPermanentAddressUpdateType(type: AddressUpdateType) {
    this.permanentAddressUpdateType = type;
    if (this.permanentAddressUpdateType === AddressUpdateType.Update) {
      this.addressCheckbox.nativeElement.checked = false;
    }
  }

  handleSearchClient() {}

  searchWithPhoneNumber() {
    if (this.searchPhone.length < 10) {
      if (this.searchPhone.length === 0) {
        this.registrationService.setResetForm(true);
      }
      return;
    }
    let payload = {
      mobile_number: this.searchPhone,
    };
    this.basicRegService.findbyMobileNumber(payload).subscribe((res: any) => {
      const patientDetails: PatientDetails = res.patient_details;
      this.patientDetailsData = patientDetails;
      if (patientDetails?.csr_id) {
        // If csr_id is not 'regular' → show radios and disable dropdown
        this.isRegularCsrSelected =
          patientDetails.csr_id !== CSR_STATUS.REGULAR_VALUE;
      } else {
        // No csr_id (old record) → enable dropdown and hide radios
        this.isRegularCsrSelected = false;
      }

      if (patientDetails) {
        this.registrationForm.patchValue({
          leadSourceId: patientDetails.lead_source_id,
          countryId: patientDetails.country_id,
          countryName: "",
          phoneNumber: patientDetails.mobile_number,
          email: patientDetails.email_id,
          patientName: patientDetails.patient_name,
          dob: new Date(patientDetails.dob),
          genderId: patientDetails.gender_id,
          genderName: "",
          currentAddress: patientDetails.address,
          currentStateId: patientDetails.state_id,
          currentStateName: "",
          currentDistrictId: this.setDistrictValue(
            patientDetails.state_id,
            patientDetails.district_id,
            "current",
          ),
          currentDistrictName: "",
          permanentAddress: patientDetails.permanent_address,
          permanentStateId: patientDetails.permanent_state_id,
          permanentStateName: "",
          permanentDistrictId: this.setDistrictValue(
            patientDetails.permanent_state_id,
            patientDetails.permanent_district_id,
            "permanent",
          ),
          permanentDistrictName: "",
          isNvfFacility: patientDetails.is_nvf_facility || false,
          isNvfOpd: patientDetails.is_avail_nvf_opd || false,
          isNvfRpp: patientDetails.is_avail_nvf_rpp || false,
          isNvfAssessment: patientDetails.is_avail_nvf_assessment || false,
          isNvfSupportRevoked: patientDetails.is_nvf_support_revoked || false,
          marketing_person_id: patientDetails.marketing_person_id,
          marketing_person_name: patientDetails.marketing_person_name,
          nvfRevokeDate: patientDetails.nvf_revoked_date
            ? new Date(patientDetails.nvf_revoked_date)
            : new Date(),
          csr_id: patientDetails?.csr_id || CSR_STATUS.REGULAR_VALUE,
        });
        if (patientDetails.is_nvf_facility) {
          this.registrationForm.get("isNvfFacility").disable();
          this.registrationForm.get("isNvfOpd").disable();
          this.registrationForm.get("isNvfRpp").disable();
          this.registrationForm.get("isNvfAssessment").disable();
        } else {
          this.registrationForm.get("isNvfFacility").enable();
          this.registrationForm.get("isNvfOpd").enable();
          this.registrationForm.get("isNvfRpp").enable();
          this.registrationForm.get("isNvfAssessment").enable();
        }
        if (patientDetails.is_nvf_support_revoked) {
          this.registrationForm.get("isNvfSupportRevoked").disable();
          this.registrationForm.get("nvfRevokeDate").disable();
        } else {
          this.registrationForm.get("isNvfSupportRevoked").enable();
          this.registrationForm.get("nvfRevokeDate").enable();
        }
        this.setCountryName();
        this.setCurrentStateName();
        //this.setCurrentDistrictName();
        this.setPermanentStateName();
        //this.setPermanentDistrictName();
        this.setLeadSorceName();
        this.setGenderName();
        this.patientDetails.emit(patientDetails);
        this.disableSearchPhone = true;
      } else {
        //this.registrationForm.reset();
        this.registrationForm.patchValue({
          phoneNumber: this.searchPhone,

          // countryId: 1,
          // countryName: 'India',
        });
        //this.registrationForm.get('isNvfFacility').enable();
        //this.registrationForm.get('isNvfOpd').enable();
        //this.registrationForm.get('isNvfRpp').enable();
        //this.registrationForm.get('isNvfAssessment').enable();
        this.resetRegistrationType.emit(true);
        this.disableSearchPhone = true;
      }
      this.rppRegService.setDiscountAmount({
        discountAmount: 0,
        discountType: "",
      });
    });
  }

  get rppRegistrationForm() {
    return this.registrationForm.get("rppRegistrationForm") as FormGroup;
  }

  get oisRegistrationForm() {
    return this.registrationForm.get("oisRegistrationForm") as FormGroup;
  }

  get assessmentRegistrationForm() {
    return this.registrationForm.get("assessmentRegistrationForm") as FormGroup;
  }

  async setDistrictValue(stateId: number, districtId: number, type: string) {
    await this.getDistrictOptions(stateId, type);
    switch (type) {
      case "current":
        this.registrationForm.get("currentDistrictId").setValue(districtId);
        const districtName = this.districtCurrentOptions.find(
          (item) => item.value === districtId,
        )?.label;
        this.registrationForm.get("currentDistrictName").setValue(districtName);
        break;
      case "permanent":
        this.registrationForm.get("permanentDistrictId").setValue(districtId);
        const permanentDistrictName = this.statePermanentOptions.find(
          (item) => item.value === stateId,
        )?.label;
        this.registrationForm
          .get("permanentStateName")
          .setValue(permanentDistrictName);
        break;
      default:
        return null;
    }
  }

  setCountryName() {
    const countryId = this.registrationForm.get("countryId").value;
    const name = this.countryOptions.find(
      (item) => item.value === countryId,
    )?.label;
    this.registrationForm.get("countryName").setValue(name);
  }

  setCurrentStateName() {
    const stateId = this.registrationForm.get("currentStateId").value;
    const name = this.stateCurrentOptions.find(
      (item) => item.value === stateId,
    )?.label;
    this.registrationForm.get("currentStateName").setValue(name);
  }

  async setCurrentDistrictName() {
    const districtId =
      await this.registrationForm.get("currentDistrictId").value;
    const name = this.districtCurrentOptions.find(
      (item) => item.value === districtId,
    )?.label;
    this.registrationForm.get("currentDistrictName").setValue(name);
  }

  setPermanentStateName() {
    const stateId = this.registrationForm.get("permanentStateId").value;
    const name = this.statePermanentOptions.find(
      (item) => item.value === stateId,
    )?.label;
    this.registrationForm.get("permanentStateName").setValue(name);
  }

  async setPermanentDistrictName() {
    const districtId = await this.registrationForm.get("permanentDistrictId")
      .value;
    const name = this.districtPermanentOptions.find(
      (item) => item.value === districtId,
    )?.label;
    this.registrationForm.get("permanentDistrictName").setValue(name);
  }

  setLeadSorceName() {
    const leadSourceId = this.registrationForm.get("leadSourceId").value;
    const name = this.leadSourceOptions.find(
      (item) => item.value === leadSourceId,
    )?.label;
    this.registrationForm.get("leadSourceName").setValue(name);
  }

  setGenderName() {
    const genderId = this.registrationForm.get("genderId").value;
    const name = this.genderOptions.find(
      (item) => item.value === genderId,
    )?.label;
    this.registrationForm.get("genderName").setValue(name);
  }

  resetNvfItems() {
    this.registrationForm.get("isNvfOpd").setValue(false);
    this.registrationForm.get("isNvfRpp").setValue(false);
    this.registrationForm.get("isNvfAssessment").setValue(false);
    this.registrationForm.get("isNvfSupportRevoked").setValue(false);
    this.registrationForm.get("nvfRevokeDate").setValue("");
  }

  setDisableNvfRevokeDate(val: boolean) {
    this.disableNvfRevokeDate = val;
  }

  validatePhoneNumber(event: KeyboardEvent) {
    this.utils.validateNumber(event);
  }

  clearPhoneSearch() {
    this.basicRegService.setLatestRppPlan(null);
    this.registrationService.setResetForm(true);
  }

  updatePhoneSearch() {
    let payload = {
      old_mobile_number: this.registrationForm.get("phoneNumber").value,
      new_mobile_number: this.newMobileNumber,
    };
    this.basicRegService.updateMobileNumber(payload).subscribe((res) => {
      this.messageService.add({
        severity: "success",
        summary: "Success",
        detail: "Mobile number updated successfully",
      });
      this.searchPhone = this.newMobileNumber.toString();
      this.searchWithPhoneNumber();
    });
  }

  onDobEnterValue(event: any) {
    const dateValue = event.trim();
    // Regular expression to match MM/DD/YYYY format
    const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (dateValue && datePattern.test(dateValue)) {
      const [month, day, year] = dateValue.split("/").map(Number);
      const dateObject = new Date(year, month - 1, day); // JavaScript months are zero-based

      // Check if date is valid
      if (
        dateObject &&
        dateObject.getMonth() === month - 1 &&
        dateObject.getDate() === day &&
        dateObject.getFullYear() === year
      ) {
        this.registrationForm.get("dob").setValue(dateObject);
      }
    }
  }
}
